import { render, staticRenderFns } from "./MyLoveUser.vue?vue&type=template&id=485bd6f6&"
import script from "./MyLoveUser.vue?vue&type=script&lang=js&"
export * from "./MyLoveUser.vue?vue&type=script&lang=js&"
import style0 from "./MyLoveUser.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports